import EventEmitter from "base/EventEmitter";

class Gallery extends EventEmitter {

    constructor($gallery, settings = {}) {
        super();
        settings = $.extend({}, Gallery.default_options, settings);

        this.settings = settings;

        this.$gallery = $gallery;
        this.$items = this.$gallery.find("." + this.settings.itemsClass);
        this.$pips = this.$gallery.find("." + this.settings.pipsClass);

        this.changing = false;
        this.applyMinHeight = this.applyMinHeight.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);

        this.bindEvents();
    }

    bindEvents() {
        const me = this;
        this.$gallery.on("click", "." + this.settings.navigateClass, function () {
            const direction = $(this).attr("data-direction");
            if (me.emit("navigate", {direction})) {
                me.navigate(direction);
            }
            return false;
        });
        this.$pips.on("click", "." + this.settings.pipClass, function () {
            const index = $(this).closest("." + me.settings.pipsClass).find("." + me.settings.pipClass).index(this);
            if (me.emit("goTo", {index})) {
                me.showItem(index);
            }
            return false;
        });

        if (this.settings.applyMinHeight) {
            $(window).on("resize", this.applyMinHeight);
            this.applyMinHeight();
        }
        if (this.settings.keyboardEvents) {
            $(window).on("keyup", this.onKeyUp);
        }
    }

    onKeyUp({which}) {
        if (which === 39 /* Right */) {
            this.navigate(Gallery.FORWARDS);
            return false;
        } else if (which === 37 /* Left */) {
            this.navigate(Gallery.BACKWARDS);
            return false;
        }
    }

    applyMinHeight() {
        this.$items.css("min-height", "");
        let height = 0;
        this.getItems().each(function () {
            height = Math.max(height, $(this).outerHeight());
        });
        this.$items.css("min-height", height + "px");
    }

    navigate(direction) {
        this.showItem(this.getItemIndex(direction), direction);
    }

    getItemIndex(direction) {
        let index = this.getActiveIndex() + (direction === DIRECTION_FORWARDS ? 1 : -1);

        if (index < 0) {
            index = this.getItemCount() - 1;
        } else if (index >= this.getItemCount()) {
            index = 0;
        }
        return index;
    }

    getItemCount() {
        return this.getItems().length;
    }

    showItem(index, direction = null) {
        if (this.changing) return;

        let from = this.getActiveIndex();

        if (this.getActiveIndex() === index) return;
        this.changing = true;

        if (direction === null) {
            direction = index > this.getActiveIndex() ? DIRECTION_FORWARDS : DIRECTION_BACKWARDS;
        }

        let inClass = this.settings.itemClass + "--in-" + direction + " " + this.settings.itemClass + "--in";
        let outClass = this.settings.itemClass + "--out-" + direction + " " + this.settings.itemClass + "--out";

        if (!this.emit("transitionStart", {
            from,
            to: index,
            direction,
        })) {
            this.changing = false;
        }

        let $current = this.getActiveElement();
        let $next = this.getItem(index);
        $next.addClass(inClass);
        $current.addClass(outClass);

        let pipActiveClass = this.settings.pipClass + "--" + this.settings.pipActiveModifier;

        // Loop through each pips wrapper element
        // This allows us to have more than one set of pips
        this.$pips.each((_, el) => {
            $(el).find("." + this.settings.pipClass).removeClass(pipActiveClass).eq(index).addClass(pipActiveClass);
        });

        let duration = 0;

        if (this.settings.animationDuration instanceof Function) {
            duration = this.settings.animationDuration.call(this, {
                from,
                to: index,
                direction,
            });
        } else if ('number' === typeof this.settings.animationDuration) {
            duration = this.settings.animationDuration;
        }

        setTimeout(() => {
            $next.removeClass(inClass).addClass(this.settings.itemClass + "--" + this.settings.itemActiveModifier);
            $current.removeClass(outClass + " " + this.settings.itemClass + "--" + this.settings.itemActiveModifier);
            this.changing = false;
            this.emit("transitionEnd", {
                from,
                to: index,
                direction,
            });
        }, duration);
    }

    getItems() {
        return this.$items.find("." + this.settings.itemClass);
    }

    getItem(index) {
        return this.getItems().eq(index);
    }

    getActiveIndex() {
        let $active = this.getActiveElement();

        return $active.length === 0 ? 0 : this.getItems().index($active);
    }

    getActiveElement() {
        return this.$items.find("." + this.settings.itemClass + "--" + this.settings.itemActiveModifier);
    }

    destroy() {
        this.$gallery.off("click", "." + this.settings.navigateClass);
        this.$gallery.off("click", "." + this.settings.pipsClass);

        this.$gallery = null;
        this.$items = null;

        $(window).off("resize", this.applyMinHeight).off("keyup", this.onKeyUp);

        this.changing = false;
    }
}

export const DIRECTION_FORWARDS = "forwards";
export const DIRECTION_BACKWARDS = "backwards";

Gallery.default_options = {
    itemClass: "gallery__image",
    pipClass: "gallery__pip",
    navigateClass: "js-navigate",
    pipsClass: "js-pips",
    itemsClass: "js-items",
    itemActiveModifier: "active",
    pipActiveModifier: "active",
    animationDuration: 250,
    applyMinHeight: false,
    keyboardEvents: false,
};

Gallery.BACKWARDS = DIRECTION_BACKWARDS;
Gallery.FORWARDS = DIRECTION_FORWARDS;

export default Gallery;
